<template>
  <div class="hello">
    <div class="tab1">
      <div class="tab1-left">
        服务电话：<span style="color: #c7171e">{{ fwmobile }}</span>
      </div>
      <div class="tab1-right">
        <!-- 正式 -->
        <div class="pointer"><a href="http://beta.zyqpm.com.cn" style="color:#000">进入测试平台</a></div>
        <!-- 测试 -->
        <!-- <div class="pointer"><a href="http://www.zyqpm.com.cn" style="color:#000">进入正式平台</a></div> -->
        <div class="pointer" @click="page('My')">个人中心</div>
        <div class="pointer" v-if="token">
          {{ mobile }}
          <span
            @click="handlePage('Login')"
            style="font-size: 12px; color: #c7171e"
            >退出</span
          >
        </div>
        <div class="pointer" v-else @click="page('Login')">登录/注册</div>
      </div>
    </div>
    <!--  -->
    <div class="tab2">
      <div class="tab2-con">
        <div class="tab2-img pointer" @click="page('Home')">
          <img src="../assets/image/logo.png" alt="" />
        </div>
        <div class="tab2-text">
          <div
            :class="
              kexs == 1 ? 'pointer tab2-box tab2-boxs' : 'pointer tab2-box'
            "
            @click="page('About')"
          >
            拍卖大厅
          </div>
          <div
            :class="
              kexs == 2 ? 'pointer tab2-box tab2-boxs' : 'pointer tab2-box'
            "
            @click="page('AuctionManagement')"
          >
            拍卖会管理
          </div>
          <div
            :class="
              kexs == 3 ? 'pointer tab2-box tab2-boxs' : 'pointer tab2-box'
            "
            @click="page('Business')"
          >
            认证商家
          </div>
          <div
            :class="
              kexs == 4 ? 'pointer tab2-box tab2-boxs' : 'pointer tab2-box'
            "
            @click="page('Notice')"
          >
            公告
          </div>
          <div
            :class="
              kexs == 5 ? 'pointer tab2-box tab2-boxs' : 'pointer tab2-box'
            "
            @click="page('Attract')"
          >
            招商信息
          </div>
        </div>
        <div class="inputer">
          <el-input
            placeholder="请输入内容"
            v-model="input2"
            @keyup.enter.native="handleAddBook()"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleClick()"
            ></el-button>
          </el-input>
        </div>
        <div class="IcoImg" @click="drawer = true">
          <img src="../assets/image/gengduo.png" alt="" />
        </div>
        <el-drawer
          title="我是标题"
          :visible.sync="drawer"
          :with-header="false"
          size="40%"
        >
          <div class="tab2-texts" @click="drawer = false">
            <div class="tab2-img" style="margin: 0 auto">
              <img src="../assets/image/logo.png" alt="" />
            </div>
            <div style="margin-top: 20px; line-height: 40px">
              <div
                :class="kexs == 0 ? 'pointer tab-boxs' : 'pointer'"
                @click="page('Home')"
              >
                首页
              </div>
              <div
                :class="kexs == 1 ? 'pointer tab-boxs' : 'pointer'"
                @click="page('About')"
              >
                拍卖大厅
              </div>
              <div
                :class="kexs == 2 ? 'pointer tab-boxs' : 'pointer'"
                @click="page('AuctionManagement')"
              >
                拍卖会管理
              </div>
              <div
                :class="kexs == 3 ? 'pointer tab-boxs' : 'pointer'"
                @click="page('Business')"
              >
                认证商家
              </div>
              <div
                :class="kexs == 4 ? 'pointer tab-boxs' : 'pointer'"
                @click="page('Notice')"
              >
                公告
              </div>
              <div
                :class="kexs == 5 ? 'pointer tab-boxs' : 'pointer'"
                @click="page('Attract')"
              >
                招商信息
              </div>
              <!-- 正式 -->
              <!-- <div
                :class="kexs == 6 ? 'pointer tab-boxs' : 'pointer'"
              >
                <a href="http://beta.zyqpm.com.cn" style="color:#fff">进入测试平台</a>
              </div> -->
              <!-- 测试 -->
              <div
                :class="kexs == 6 ? 'pointer tab-boxs' : 'pointer'"
              >
                <a href="http://www.zyqpm.com.cn" style="color:#fff">进入正式平台</a>
              </div>
              <div
                :class="kexs == 7 ? 'pointer tab-boxs' : 'pointer'"
                @click="page('My')"
              >
                个人中心
              </div>
              <div v-if="token" @click="handlePage('Login')">退出登录</div>
              <div
                v-else
                :class="kexs == 8 ? 'pointer tab-boxs' : 'pointer'"
                @click="page('Login')"
              >
                登录/注册
              </div>
            </div>
          </div>
        </el-drawer>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  name: "tab",
  props: ["kexs"],
  data() {
    return {
      input2: "",
      drawer: false,
      mobile: localStorage.getItem("mobile"),
      fwmobile: "",
      token: localStorage.getItem("token") ? true : false,
    };
  },
  mounted() {
    this.$apis.getcommoninfo().then((res) => {
      this.fwmobile = res.data.contactinformation[0];
    });
  },
  methods: {
    page(e) {
      if (e == "My" && !localStorage.getItem("token")) {
        Dialog.confirm({
          message: "您未登录，请登录",
        })
          .then(() => {
            this.$router.push({
              name: "Login",
            });
          })
          .catch(() => {});
      } else {
        this.$router.push({
          name: e,
          query: {
            id: 1,
          },
        });
      }
    },
    // 退出登录
    handlePage() {
      Dialog.confirm({
        title: "提示",
        message: "您确定退出登录吗？",
      })
        .then(() => {
          this.$apis
            .logout({
              token: localStorage.getItem("token"),
            })
            .then((res) => {
              if (res.code == 1) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
              }

              localStorage.clear();
              this.$router.push({
                name: "Login",
              });
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    handleClick() {
      let ok = window.location.href.indexOf("About") == -1;
      console.log(ok);
      if (ok) {
        this.$router.push({
          name: "About",
          params: {
            title: this.input2,
          },
        });
      } else {
        this.$parent.handlelist(this.input2);
        sessionStorage.setItem("title", this.input2);
      }
    },
    handleAddBook() {
      this.handleClick();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped='scoped'>
.login {
  background-color: #f5f5f5;
  overflow-x: hidden;
}
img {
  width: 100%;
  height: 100%;
}
h2 {
  font-size: 18px;
  color: #000;
}
/* 顶部 */
.tab1 {
  width: 1136px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  padding: 9px;
}
.tab1-right {
  display: flex;
  align-items: center;
}
.tab1-right div {
  margin-left: 24px;
}
/* 顶部红色导航 */
.tab2 {
  background-color: #c7171e;
}
.tab2-con {
  width: 1136px;
  margin: 0 auto;
  padding: 7px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tab2-text {
  width: 57%;
  justify-content: space-around;
  font-size: 20px;
  color: #fff;
  /* margin-top: 11px; */
  display: flex;
}
.tab2-img {
  width: 98px;
  height: 54px;
}
.option {
  color: #c7171e;
}
.inputer {
  width: 240px;
  /* margin-top: 15px; */
}
.el-input >>> .el-input-group__append {
  border-radius: 0 50px 50px 0;
}
.el-input >>> .el-input__inner {
  border-radius: 50px 0 0 50px;
  height: 33px;
  line-height: 33px;
}
.IcoImg {
  width: 50px;
  height: 50px;
  display: none;
}
.tab2-texts {
  background-color: #c7171e;
  font-size: 20px;
  height: 100%;
  color: #fff;
  text-align: center;
  padding: 20px 0;
}
.tab2-box {
  padding: 6px 16px;
  border-radius: 20px;
}
.tab2-boxs {
  background-color: #fff;
  color: #c7171e;
  font-weight: bold;
}
.tab-boxs {
  background-color: #fff;
  color: #c7171e;
  font-weight: bold;
}
@media screen and (min-width: 991px) and (max-width: 1160px) {
  .tab1,
  tab2,
  .tab2-con {
    width: 100%;
  }
  .tab2-text {
    font-size: 20px;
  }

  .tab2-box {
    padding: 6px 11px;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .footer-a,
  .footer-bot {
    width: 60%;
  }
  .tab1,
  tab2,
  .tab2-con {
    width: 100%;
  }
  .tab2-text {
    font-size: 16px;
  }
  .inputer {
    width: 190px;
  }
  .tab2-box {
    padding: 6px 4px;
  }
}
@media only screen and (max-width: 767px) {
  .tab1,
  .tab2-text {
    display: none;
  }
  .tab2-con {
    width: 100%;
  }

  .inputer {
    width: 190px;
    margin-bottom: 10px;
  }
  .IcoImg {
    width: 30px;
    height: 30px;
    display: inline-block;
  }
  .tab2-img {
    width: 82.5px;
    height: 47.5px;
  }
  .el-drawer__container >>> .el-drawer {
    width: 40%;
  }
  .el-input >>> .el-input__inner {
    height: 35px;
    line-height: 35px;
  }
  .inputer {
  margin-top: 15px;
}
}
</style>
